import * as React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useI18n } from "../i18n/I18nProvider";


type Props = {
  handlePageChange: (page: string) => void;
};

export default function Footer({ handlePageChange }: Props) {
  const { t } = useI18n();
  return (
    <Box
      component="footer"
      sx={{
        py: 1.5,
        px: 2,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",

        /* light gradient - visual closure without darkness */
        background: `
          linear-gradient(
            90deg,
            #000000 0%,
            #8d0000b1 50%,
            #000000 100%
          )
        `,
      }}
    >
      <Stack spacing={0.4} alignItems="center">
        <Typography
          sx={{
            fontSize: 12.5,
            fontWeight: 600,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: "#ffffffc0",
          }}
        >
          {t("footer.rights")}
        </Typography>

        <Stack direction="row" spacing={1.5} alignItems="center">
          <Typography
            onClick={() => handlePageChange("Terms")}
            sx={{
              fontSize: 12,
              cursor: "pointer",
              color: "#ffffff66",
              transition: "0.2s",
              "&:hover": {
                color: "#ffffff",
                textDecoration: "underline",
              },
            }}
          >
            Terms & Conditions
          </Typography>
        
          <Typography sx={{ fontSize: 11, color: "#ffffff66" }}>
            |
          </Typography>
        
          <Typography
            onClick={() => handlePageChange("Privacy")}
            sx={{
              fontSize: 12,
              cursor: "pointer",
              color: "#ffffff66",
              transition: "0.2s",
              "&:hover": {
                color: "#ffffff",
                textDecoration: "underline",
              },
            }}
          >
            Privacy Policy
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
